import { ClockLoader } from 'react-spinners';

export const Spinner = () => {
	return (
		<div className="spinner">
			<ClockLoader color="#fff" size={32} />
		</div>
	);
};
